import { render, staticRenderFns } from "./PastActivityList.vue?vue&type=template&id=48db13c4&scoped=true"
import script from "./PastActivityList.vue?vue&type=script&lang=js"
export * from "./PastActivityList.vue?vue&type=script&lang=js"
import style0 from "./PastActivityList.vue?vue&type=style&index=0&id=48db13c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db13c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VProgressCircular,VRow})
